  <template>
  <div>
   <b-modal @hidden = resetModel() :ok-only = true @show = "updateModel()" style="padding:15px" size="lg" id="CurrentStatusDetailsModal" ref="modal" title="Current Status Details">
        <form ref="CurrentStatusDetailsForm" @submit.stop.prevent= "handleSubmit">
         <b-card>
            
            <table class="table table-striped table-borderless cutom-table table-grey table-striped table-sm" 
              style="font-size: 85%;">
                <thead>
                  <tr>
                
                    <th role="columnheader">Flour Type(Bag Type)</th>
                    <th role="columnheader">No Of Sacks</th>
                     <th role="columnheader">Stock Take Description</th>
                    <th role="columnheader">Date and Time</th>
                  </tr>
                </thead>
                <tbody>
                  <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
                  <tr v-if= "currentStatusDetails == null" >
                    <td class = "center-td" colspan="4">No Items Added</td>
                  </tr>
                  
                <tr v-else v-for="entry in currentStatusDetails" :key=entry.id>
                
                  <td  role="cell">{{entry.flourType}}&nbsp;({{entry.flourWeight}})</td>
                  <td  role="cell">{{entry.noOfSacks}}</td>
                  <td  role="cell">{{entry.description}}</td>
                  <td  role="cell">{{entry.date|moment("MMMM Do YYYY, h:mm:ss a")}}</td>
                 
                </tr>
              </tbody>
            </table>
            <div class="text-center">
            <b-spinner v-if="isLoading" label="Loading..."></b-spinner>
            </div>
        </b-card>
          
        </form>
      </b-modal>
      <Toaster ref ="toaster"/>
      </div>
      </template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'CurrentStatusDetails',
   
    components:{
      Toaster
    },
    data(){
        return{
          moduleName:'Current Status Details',   
         isLoading:false,
          currentStatusDetails:null,
          
		}
  },
  props:{
      toFetchDetails:{
          type : Object,
          default: null
      },
  },
 
methods:{
 
 resetModel()
 {
    this.currentStatusDetails = null;
    this.isLoading = false;
 },
 updateModel()
 {
  //  console.log(this.toFetchDetails)
     this.getCurrentStatusDetails();
    //  console.log("in show")
 },
  getCurrentStatusDetails()
  {
      this.isLoading = true;
    axios.post('/currentStatus/getdetails/',{
      "Identifier":this.toFetchDetails.stockTakeIdentifier,
      "CompanyId":this.$auth.user().companyId
      })
    .then(res=>{
        this.isLoading = false;
        // console.log(res.data)
        if(res.data.status == 1)
        {
          this.currentStatusDetails = res.data.data
        }
    });
  }
},
   

}
</script>
